export const RQASIM = "Innovera RQASim™";

export const LABEL_2 =
  "text-[14px] font-medium leading-[13px] text-innoveraZinc-900 [text-box-trim:trim-both] [text-box-edge:cap_alphabetic]";
export const BODY_2 = "text-[14px] leading-[22px]";
export const BODY_3 = "text-[12px] leading-[18px]";

export const FIELD =
  "h-8 rounded-lg border border-innoveraZinc-150 bg-white px-3 py-2 text-[14px] leading-[22px] text-innoveraZinc-900 outline-hidden placeholder:text-innoveraZinc-400 focus:border-innoveraZinc-300";

export const ROBOTO_MONO = "font-['Roboto_Mono',ui-monospace,monospace]";
